export interface ReportField {
    key: string;
    label: string;
    isSelected?: boolean;
}

export const requiredExportFieldsProductionDetailsKey = [
    'POLICY_NO',
    'LEAD'
]

export const requiredExportFieldsPerformanceKey = [
    'USER'
]

export const requiredExportFieldsLeadKey = [
    'USER'
]

export const requiredExportFieldsNoteKey = [
    'LEAD_ID',
    'LEAD_NAME'
]